import React from 'react';
import './NewVendPro.css';
const NewVendProSuccess = () => {
  return (
    <div className='text-center'><img src="verify-circle.png" className='mt-5'></img>
    <p className='verify-text'>We have received your request for selling on Toolsvilla. Our supplier onboarding team will verify this request soon.</p>


<button className='ok-button' onClick={()=>window.location.assign('/homenew')}>OK</button>

</div>
  )
}

export default NewVendProSuccess;